import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import Api from "../../util/Api";
import ConfigurationPage from "templates/ConfigurationPage";
import {Message, useToaster} from "rsuite";

function DevicesEdit({ auth, selectedDevices, history }) {
  const [devices] = useState(selectedDevices);
  const [deviceRow, setDeviceRow] = useState([]);
  const [facilities, setFacilities] = useState([]);
  const [devicesToEdit, setDevicesToEdit] = useState([]);
  let reactKey = 0;
  const toaster = useToaster();

  /**
   * Load everything.
   */
  useEffect(async () => {
    buildDropDowns(await fetchFacilities());
  }, []);

  /**
   * Get all the facilities, sections, rooms/beds for the logged in user's default org.
   * @returns {*}
   */
  const fetchFacilities = async () => {
    console.log({auth});
    return Api.withAuth(auth)
      .getOrgDeviceEditList(auth.currentUser.defaultOrg)
      .then((response) => {
        console.log({response});
        setFacilities(response);
        return response;
      })
      .catch(() => {
        toaster.push(
            <Message type="warning">
              <h6>Warning</h6>
              <p className='m-0'>Cannot load data, please try again later</p>
            </Message>,
            {
              placement: "topEnd"
            });
      });
  }

  /**
   * Room name will be a combo of Room Name and if exists the bed name.
   * @param room_name
   * @param bed_name
   * @returns {*}
   */
  const buildRoomName = (room_name, bed_name) => {
    return room_name + (bed_name ? " - " + bed_name : "");
  }

  /**
   * Build all the dropdowns for the grid rows.
   * @param facilityList
   */
  const buildDropDowns = (facilityList) => {
    // Loop through the devices selected on the previous page.
    const newList = devices.map((device) => {
      // eslint-disable-next-line prefer-const
      let [facilityDropDownList, sectionDropDownList, bedDropDownList] = [
        {
          defaultValue: "",
          options: Object.keys(facilityList),
        },
        {
          defaultValue: "",
          options: [],
        },
        {
          defaultValue: "",
          options: [],
        },
      ];
      // If the device is deployed then we should populate the section and bed dropdowns and
      // set the default value to the location the device is deployed to.
      if (device.state === "deployed") {
        // Populate facility dropdown.
        facilityDropDownList.defaultValue = device.location.facility;
        // Populate section dropdown
        sectionDropDownList = {
          defaultValue: device.location.section,
          options: Object.keys(facilityList[device.location.facility]),
        };
        const bedList =
          facilityList[device.location.facility][device.location.section];
        // If a device has been deployed then the bed that it's currently assigned to won't be in the
        // facility list, so let's add it
        const selectedBed = {
          bed_id: device.location.bed_id,
          room_name: buildRoomName(
            device.location.room_name,
            device.location.bed_name
          ),
          patient: device.resident
            ? `${device.resident.first_name} ${device.resident.last_name}`
            : "",
          selected: true,
        };
        device.selectedPatient = device.resident
          ? `${device.resident.first_name} ${device.resident.last_name}`
          : "";
        console.log({selectedBed});
        console.log({bedList});
        const bedListFull = bedList ? [...bedList, ...[selectedBed]] : [];
        bedDropDownList = {
          defaultValue: device.location.bed_id,
          options: bedListFull,
        };
      }

      return {
        ...device,
        facilityDropDownList,
        sectionDropDownList,
        bedDropDownList,
      };
    });
    setDeviceRow(newList);
  }

  /**
   * Handle when any of the facility dropdowns change.
   * We need to reload the sections, set section to default, and reload the rooms
   * @param e
   */
  const handleFacilityChange = (e) => {
    const newDropDowns = deviceRow.map((d) => {
      if (e.target.dataset.deviceId === d.device_id) {
        const facilitySelected = e.target.value;
        d.facilityDropDownList.defaultValue = facilitySelected;
        d.sectionDropDownList.defaultValue = "";
        d.sectionDropDownList.options = facilitySelected
          ? Object.keys(facilities[facilitySelected])
          : [];
        d.bedDropDownList.defaultValue = "";
        d.bedDropDownList.options = [];
        d.selectedPatient = "";
      }
      return d;
    });
    setDeviceRow(newDropDowns);
  }

  /**
   * When the section dropdown has been changed.
   * @param e
   */
  const handleSectionChange = (e) => {
    const newDropDowns = deviceRow.map((d) => {
      if (e.target.dataset.deviceId === d.device_id) {
        d.sectionDropDownList.defaultValue = e.target.value;
        d.bedDropDownList.defaultValue = "";
        d.bedDropDownList.options = e.target.value
          ? facilities[d.facilityDropDownList.defaultValue][e.target.value]
          : [];
        d.selectedPatient = "";
      }
      return d;
    });
    setDeviceRow(newDropDowns);
  }

  /**
   * When the bed dropdown has changed.
   * @param e
   */
  const handleBedChange = (e) => {
    const selectedDeviceId = e.target.dataset.deviceId;
    const bedId = e.target.value;
    const newDropDowns = deviceRow.map((d) => {
      if (selectedDeviceId === d.device_id) {
        d.bedDropDownList.defaultValue = bedId;
        const patient = d.bedDropDownList.options.find(
          ({ bed_id }) => bed_id === e.target.value
        );
        d.selectedPatient = patient && patient.patient;
        if (bedId) {
          const uniqueDevices = devicesToEdit.filter(
            (device) => device.device_id !== selectedDeviceId
          );
          setDevicesToEdit([
            ...uniqueDevices,
            { device_id: d.device_id, bed_id: bedId },
          ]);
        }
      }
      return d;
    });
    setDeviceRow(newDropDowns);
  }

  const handleEditDevices = (event) => {
    console.log(`Edit devices ${event}`);
    Api.withAuth(auth)
      .editDevices(devicesToEdit)
      .then((response) => response)
      .catch((error) => {
        console.log(error);
      });
    history.push("/configuration/devices");
  }
  function handleCancel(e) {
    e.preventDefault();
    history.goBack();
  }
  function getPatientName(bedOptions) {
    return bedOptions.patient ? ` (${bedOptions.patient})` : "";
  }

  return (
    <ConfigurationPage pageTitle="Devices" pageSubTitle="Edit Device" history={history}>
      <ConfigurationPage.Content>
        <table className="table device-table table-bordered">
          <thead>
            <tr>
              <th>Device ID</th>
              <th>Location</th>
              <th>&nbsp;</th>
              <th>&nbsp;</th>
              <th>Current Resident</th>
            </tr>
          </thead>
          <tbody>
            {deviceRow &&
              deviceRow.map((d, key) => (
                <tr key={key}>
                  <td>{d.device_id}</td>
                  <td>
                    <div className="select-wrapper">
                      <select
                        data-device-id={d.device_id}
                        value={d.facilityDropDownList.defaultValue}
                        className="form-control"
                        onChange={handleFacilityChange}
                      >
                        <option value="" key={reactKey++}>
                          Select Location
                        </option>
                        {d.facilityDropDownList.options.map((facilityOptions) => (
                          <option value={facilityOptions} key={reactKey++}>
                            {facilityOptions}
                          </option>
                        ))}
                      </select>
                    </div>
                  </td>
                  <td>
                    <div className="select-wrapper">
                      <select
                        data-device-id={d.device_id}
                        value={d.sectionDropDownList.defaultValue}
                        className="form-control"
                        onChange={handleSectionChange}
                        disabled={d.sectionDropDownList.options.length === 0}
                      >
                        <option value="" key={reactKey++}>
                          Select Section
                        </option>
                        {d.sectionDropDownList.options.map((sectionOptions) => (
                          <option value={sectionOptions} key={reactKey++}>
                            {sectionOptions}
                          </option>
                        ))}
                      </select>
                    </div>
                  </td>
                  <td>
                    <div className="select-wrapper">
                      <select
                        data-device-id={d.device_id}
                        value={d.bedDropDownList.defaultValue}
                        className="form-control"
                        onChange={handleBedChange}
                        disabled={d.bedDropDownList.options.length === 0}
                      >
                        <option value="" key={reactKey++}>
                          Select Bed
                        </option>
                        {d.bedDropDownList.options.map((bedOptions) => (
                          <option value={bedOptions.bed_id} key={reactKey++}>
                            {buildRoomName(
                              bedOptions.room_name,
                              bedOptions.bed_name
                            ) + getPatientName(bedOptions)}
                          </option>
                        ))}
                      </select>
                    </div>
                  </td>
                  <td>
                    {d.resident &&
                      `${d.resident.first_name} ${d.resident.last_name}`}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        <div className="actions row" style={{ marginTop: 20 }}>
          <div className="col-md-12 text-right">
            <button
              className="btn btn-secondary mx-2 px-5"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary mx-2 px-5"
              onClick={handleEditDevices}
              disabled={devicesToEdit.length === 0}
            >
              Apply Changes
            </button>
          </div>
        </div>
      </ConfigurationPage.Content>
    </ConfigurationPage>
  );
}

export default withRouter(DevicesEdit);
